export enum FileTypeEnum {
  IMAGE = "image",
  TABLE = "table",
  MODEL = "model",
}
